import * as React from "react";
import { cn } from "@/utils/tailwind";
import { Slot } from "@radix-ui/react-slot";

interface Props extends React.HTMLAttributes<HTMLSpanElement> {
  loading?: boolean;
}

function Skeleton({ className, loading = true, children, ...props }: Props) {
  if (!loading) return children;
  const Element = React.isValidElement(children) ? Slot : "span";
  return (
    <Element
      tabIndex={-1}
      aria-hidden={true}
      className={cn(
        "animate-pulse rounded-md bg-grey-100 pointer-events-none select-none *:invisible text-transparent",
        className,
      )}
      {...props}
    >
      {children}
    </Element>
  );
}

export { Skeleton };
